import { render, staticRenderFns } from "./ServiceProviderDetail.vue?vue&type=template&id=17a95b0a"
import script from "./ServiceProviderDetail.vue?vue&type=script&lang=js"
export * from "./ServiceProviderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports